"use client";

import Link from "@/components/LocalizedLink";
import type { ReactElement } from "react";
import { trackEvent } from "@/lib/analytics";

interface LocationCardProps {
  slug: string;
  city: string;
  tierLabel: string;
  heroLede: string;
  latencyLabel: string;
  serviceCount: number;
  servicesLabel: string;
}

export function LocationCard({
  slug,
  city,
  tierLabel,
  heroLede,
  latencyLabel,
  serviceCount,
  servicesLabel,
}: LocationCardProps): ReactElement {
  return (
    <Link
      href={`/locations/${slug}/`}
      onClick={() =>
        trackEvent("location_card_click", {
          location: slug,
          city,
          tier: tierLabel.toLowerCase(),
          surface: "locations_index",
        })
      }
      className="group p-6 rounded-2xl border border-border hover:border-accent transition-colors bg-surface-light/40"
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-mono tracking-wider text-muted-foreground">
          {tierLabel}
        </span>
        <span className="text-xs font-mono text-accent opacity-0 group-hover:opacity-100 transition-opacity">
          →
        </span>
      </div>
      <h2 className="text-xl font-bold text-foreground mb-2">{city}</h2>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
        {heroLede}
      </p>
      <div className="flex items-center gap-3 text-xs font-mono tracking-wider text-muted-foreground">
        <span>{latencyLabel}</span>
        <span className="opacity-50">·</span>
        <span>{serviceCount} {servicesLabel}</span>
      </div>
    </Link>
  );
}
